import type { DispatchTier } from '@sparkai/shared-types'

import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type SkyviewProgramMeta = {
  id: string
  name: string
  displayName: string
  iconType: string
  color: string
}

type CurrentSkyviewOfProgramsResponse = {
  program: SkyviewProgramMeta
  totalOfEngagementsToday: number
}

type SkyviewUserProfile = {
  id: string
  name: string
  avatarUrl: string
}

export type CurrentSkyviewActiveSuspension = {
  liveProgramId: string
  origin: 'manual' | 'automated'
}

export type CurrentSkyviewMissionSpecialist = {
  user: SkyviewUserProfile
  eligiblePrograms: string[]
  activeSuspensions?: CurrentSkyviewActiveSuspension[]
  lastState: 'ONLINE' | 'IDLE' | 'OFFLINE'
  lastWorkedEngagement: LastEngagementOfMSSkyview | null
}

type LastEngagementOfMSSkyview = {
  id: string
  taskId: string
  workedAt: string
  priority: 'high' | 'low'
  dispatchTier: DispatchTier | null
  program: SkyviewProgramMeta
}

export type CurrentSkyviewResponse = {
  currentInProgressShiftsCount: number
  plannedShiftsCount: number
  programsOverview: CurrentSkyviewOfProgramsResponse[]
  missionSpecialists: CurrentSkyviewMissionSpecialist[]
}

export function useCurrentSkyview() {
  return useQuery({
    queryKey: [CURRENT_SKYVIEW_KEY],
    refetchInterval: 10000,
    queryFn: async () => {
      const response = await apiClient.get<CurrentSkyviewResponse>('/int/v3/skyview/current')
      return response.data
    },
  })
}

const CURRENT_SKYVIEW_KEY = 'current-skyview-v3'
